export default function CalendarHeader({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <div className="flex min-[550px]:flex-row flex-col items-center justify-between p-4 gap-4 border-b">
      {children}
    </div>
  )
}
